<template>
    <div class="row">
        <div class="col-lg-12">
            <object style="min-height: 450px; width: 100%" data="https://embed.windy.com/embed2.html?lat=35.934&amp;lon=127.474&amp;zoom=6&amp;level=surface&amp;overlay=waves&amp;menu=&amp;message=&amp;marker=&amp;calendar=&amp;pressure=&amp;type=map&amp;location=coordinates&amp;detail=&amp;detailLat=36.342&amp;detailLon=126.508&amp;metricWind=default&amp;metricTemp=default" type="text/html" name="weatherko" frameborder="0" scrolling="yes" ></object>
        </div>
    </div>
</template>
<script>

export default {
    name: "windy",
    components: {

    },
    data() {
        return {
            
        }
    },
    mounted() {
    },
    methods: {
    }
};
</script>
<style>
</style>
